import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import teamNonmemberGraphic from '../../assets/team-nonmember-graphic.svg';

export const NonmemberMessage = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-top: 100px;
  img {
    // width: 186px;
    // height: 107px;
    margin-bottom: 18px;
  }
  h1 {
    margin: 0;
    margin-bottom: 12px;
    font-size: 34px;
  }
  p {
    margin: 0;
    font-size: 16px;
  }
`;

const Block = styled.div`
  max-width: 345px;
`;

export const InviteOnlyTeam = ({teamName}: {teamName: string}) => (
  <NonmemberMessage data-test="team-nonmember-view">
    <img height={107} width={186} src={teamNonmemberGraphic} alt="nonmember" />
    <Block>
      <h1>{`${teamName} is an invite-only team.`}</h1>
      <p>
        Received an invite but still can't see the team? Make sure you are
        logged in with the email where you received the invite.
      </p>
    </Block>
  </NonmemberMessage>
);
